// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700&display=swap.css);"]);
// Module
exports.push([module.id, ".product-rating ul[data-v-42689b38]{list-style:none;padding:0;margin:0;display:flex}.product-rating ul li[data-v-42689b38]{display:inline;margin-right:1px}.product-rating ul li[data-v-42689b38]:last-child{margin-right:0}.product-rating ul li svg.rating-icon[data-v-42689b38]{display:block;font-size:var(--rating-icon-size);color:var(--rating-color)}", ""]);
// Exports
module.exports = exports;
